module.exports = __webpack_public_path__ + "img/avatar_random_3.1a8eef1b.png";